export default {
    /**
     * Datos añadidos a data por el mixin:
     * - factaIndicators: array con tipos de indicadores
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            factaIndicators: []
        };
    },
    methods: {
        /**
         * Load Indicators types
         */
        loadFatcaIndicatorsOptions() {
            const indicatorsTypes = this.$t(`interveners.fatca.indicators`);
            this.factaIndicators = Object.entries(indicatorsTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de indicadores en la variable
     * `this.factaIndicators`
     */
    beforeMount() {
        this.loadFatcaIndicatorsOptions();
    }
};

